export enum UsersDisiplinaryFilterEnum {
    Suspended = 1,
    Blacklist = 2
}
